(ns ductile.ui.routes
  (:require #?@(:cljs [ductile.time.js-types])
            [clojure.set :as set]
            [clojure.string :as str]
            [ductile.compound-config :as compound-config]
            [ductile.scope-auth :as scope-auth]
            [ductile.ui.locale :as locale :refer [tr]]
            [reitit.core :as r]
            [reitit.impl]
            [reitit.trie]))

(def routes
  ;; NB: will be merged with `ductile.server.routes/routes`; avoid conflicts
  [["/"
    {:layout true
     :view 'ductile.ui.auth/render-frontpage
     :module :module/base}]

   ["/auth/verify-email"
    {:module :module/base
     :view 'ductile.ui.auth/render-verify-email
     :unauthenticated? true}]

   ["/auth/forgot-password"
    {:view 'ductile.ui.auth/render-forgot-password
     :module :module/base
     :unauthenticated? true}]

   ["/auth/reset-password/:password-reset-token"
    {:view 'ductile.ui.auth/render-reset-password
     :module :module/base
     :unauthenticated? true}]

   ["/agent"
    {:view 'ductile.ui.agent/view
     :scope :scope/ai-agent
     :module :module/workflow
     :layout true}]

   ["/compound/:compound-name"
    {:compound? true
     :layout true
     :scope :scope/compound-dashboard
     :module :module/workflow
     :fetch 'ductile.insights.compound-dashboard/handle-fetch
     :view 'ductile.ui.compound/compound-dashboard-view}]

   ["/compound/:compound-name/vehicle/:fahrzeug-id"
    {:module :module/workflow
     :scope :scope/inspect-workflow
     :name :nav/vehicle-overview
     :layout true
     :view 'ductile.ui.fahrzeug/render-vehicle-overview
     :fetch 'ductile.workflow/build-fahrzeug}]

   ["/compound/:compound-name/elog-importer"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :view 'ductile.ui.elog/render-importer
     :layout true}]

   ["/compound/:compound-name/workflows"
    {:module :module/billing
     :scope :scope/billing
     :layout true
     :fetch 'ductile.contract/workflow-contracts
     :view 'ductile.ui.workflow-visualization/workflow-contracts
     :enabled-compounds #{"Eitting" "Krefeld" "Lonato" "Ravenna"}}]

   ["/contract-terms-dashboard"
    {:module :module/billing
     :scope :scope/developer
     :fetch 'ductile.contract-terms/dashboard
     :view 'ductile.ui.contract/terms-dashboard
     :layout true}]

   ["/contract-terms"
    {:module :module/billing
     :scope :scope/billing
     :fetch 'ductile.contract-terms/overview
     :view 'ductile.ui.contract/overview
     :layout true}]

   ["/contract-terms/{ductile/id}"
    {:module :module/billing
     :scope :scope/billing
     :fetch 'ductile.contract-terms/overview
     :view 'ductile.ui.contract/overview
     :layout true}]

   ["/compound/:compound-name/statistics"
    {:module :module/billing
     :scope :scope/billing
     :layout true
     :fetch 'ductile.insights.compound-dashboard/statistics-fetch
     :view 'ductile.ui.compound/compound-statistics-view}]

   ["/fuel-prices"
    {:module :module/billing
     :scope :scope/manage-fuel-prices
     :layout true
     :fetch 'ductile.fuel-prices/list-fuel-prices
     :view 'ductile.ui.billing/list-fuel-prices}]

   ["/fuel-prices/new"
    {:module :module/billing
     :scope :scope/manage-fuel-prices
     :layout true
     :fetch 'ductile.fuel-prices/show-fuel-prices-fields
     :view 'ductile.ui.workflow/form}]

   ["/fuel-prices/:year-month/edit"
    {:module :module/billing
     :scope :scope/manage-fuel-prices
     :layout true
     :fetch 'ductile.fuel-prices/show-fuel-prices-fields
     :view 'ductile.ui.workflow/form}]

   ["/compound/:compound-name/lead-times"
    {:enabled-compounds #{"Krefeld"}
     :compound? true
     :module :module/workflow
     :scope :scope/dispo
     :layout true
     :fetch 'ductile.insights.bmw-lead-times/lead-times-fetch
     :view 'ductile.ui.compound/lead-times-view}]

   ["/insights/elog/lead-times"
    {:module :module/workflow
     :scope :scope/dispo
     :layout true
     :view 'ductile.ui.compound/elog-lead-times-view}]

   ["/vehicle/:fahrzeug-id"
    {:module :module/workflow
     :scope :scope/inspect-workflow
     :name :nav/fahrzeug-overview
     :layout true
     :fetch 'ductile.workflow/build-fahrzeug
     :view 'ductile.ui.fahrzeug/render-vehicle-overview}]

   ["/compound/:compound-name/vehicle/:fahrzeug-id/workflow-history"
    {:compound? true
     :view 'ductile.ui.workflow/render-history
     :module :module/workflow
     :scope :scope/inspect-workflow}]

   ["/compound/:compound-name/entry-protocol/:service-id"
    {:module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :fetch 'ductile.workflow/entry-protocol
     :view 'ductile.ui.entry-protocol/view}]

   ;; should be rolled into compound dashboard
   ["/compound/:compound-name/transport-orders"
    {:compound? true
     :module :module/workflow
     :scope :scope/inspect-workflow
     :view 'ductile.ui.compound/render-transport-orders}]

   ["/compound/{compound/name}/vehicle-search"
    {:compound? true
     :module :module/workflow
     :scope :scope/vehicle-search
     :layout true
     :fetch 'ductile.vehicle-search/fetch+search
     :ductile.vehicle-search/use-case :vehicle-search
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/compound/:compound-name/workflow-generator"
    {:compound? true
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :view 'ductile.ui.workflow-generator/render-edit-workflow}]

   ["/compound/{compound/name}/vehicle-search-test/:vin-count"
    {:fetch 'ductile.vehicle-search/on-load-test
     :scope :scope/inspect-workflow
     :module :module/workflow
     :layout true}]

   ["/compound/{compound/name}/vehicle-call-off"
    {:enabled-compounds #{"Eitting" "Krefeld" "Lonato" "Civitavecchia" "Fiumicino" "Ravenna"
                          "Knautnaundorf"}
     :scope :scope/inspect-workflow
     :compound? true
     :layout true
     :ductile.vehicle-search/use-case :call-off
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search
     :module :module/workflow}]

   ["/entity-history/{entity/id}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.datomic.tx-log/entity-attr-history+tx-data
     :view 'ductile.ui.workflow/entity-history}]

   ["/entity-history/{entity/id}/{tx}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.datomic.tx-log/entity-attr-history+tx-data
     :view 'ductile.ui.workflow/entity-history}]

   ["/wizard/{wizard/name}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.lambda/show-wizard
     :view 'ductile.ui.workflow/wizard}]

   ["/wizard/{wizard/name}/{ductile/base64-edn}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.lambda/show-wizard
     :view 'ductile.ui.workflow/wizard}]

   ["/compound/{compound/name}/wizard/{wizard/name}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.lambda/show-wizard
     :view 'ductile.ui.workflow/wizard}]

   ["/compound/{compound/name}/wizard/{wizard/name}/{ductile/base64-edn}"
    {:module :module/workflow
     :layout true
     :fetch 'ductile.lambda/show-wizard
     :view 'ductile.ui.workflow/wizard}]

   ["/compound/{compound/name}/batch-call-off/{ductile/base64-edn}"
    {:enabled-compounds #{"Eitting" "Knautnaundorf"}
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :fetch 'ductile.workflow.engine/show-batch-call-off-fields
     :view 'ductile.ui.workflow/form}]

   ["/compound/{compound/name}/create-entry-transport"
    {:compound? true
     :enabled-compounds #{"Krefeld" "Civitavecchia" "Ravenna" "Lonato"}
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :ductile.vehicle-search/use-case :create-entry-transport
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/compound/{compound/name}/create-exit-transport"
    {:compound? true
     :enabled-compounds #{"Eitting" "Krefeld" "Ravenna" "Knautnaundorf" "Lonato" "Civitavecchia"}
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :ductile.vehicle-search/use-case :create-exit-transport
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/insights/{compound/name}/inventory"
    {:compound? true
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :ductile.vehicle-search/use-case :inventory
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/insights/{compound/name}/entry"
    {:compound? true
     :enabled-compounds #{"Krefeld" "Ravenna"}
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :ductile.vehicle-search/use-case :entry-report
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/insights/{compound/name}/exit"
    {:compound? true
     :enabled-compounds #{"Krefeld" "Ravenna"}
     :module :module/workflow
     :scope :scope/inspect-workflow
     :layout true
     :ductile.vehicle-search/use-case :exit-report
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :fetch 'ductile.vehicle-search/fetch+search
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/compound/{compound/name}/passive-custody"
    {:compound? true
     :enabled-compounds #{"Lonato" "Civitavecchia" "Fiumicino" "Ravenna"}
     :module :module/workflow
     :scope :scope/kia-passive-custody
     :fetch 'ductile.vehicle-search/fetch+search
     :layout true
     :ductile.vehicle-search/use-case :passive-custody
     :view 'ductile.ui.vehicle-search/render-vehicle-search
     :on-fetch :ductile.ui.vehicle-search/on-fetch}]

   ["/compound/{compound/name}/customer-portal"
    {:compound? true
     :enabled-compounds #{"Lonato" "Fiumicino" "Civitavecchia" "Ravenna"}
     :module :module/workflow
     :scope :scope/customer-portal
     :fetch 'ductile.vehicle-search/fetch+search
     :layout true
     :ductile.vehicle-search/use-case :customer/portal
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/compound/{compound/name}/insurance-portal"
    {:compound? true
     :enabled-compounds #{"Krefeld" "Eitting" "Knautnaundorf"}
     :module :module/workflow
     :scope #{:scope/claimsecur-insurance-portal :scope/developer}
     :fetch 'ductile.vehicle-search/fetch+search
     :layout true
     :ductile.vehicle-search/use-case :claimsecur/insurance-portal
     :on-fetch :ductile.ui.vehicle-search/on-fetch
     :view 'ductile.ui.vehicle-search/render-vehicle-search}]

   ["/compound/:compound-name/load-builder"
    {:compound? true
     :enabled-compounds #{"Eitting" "Knautnaundorf" "Krefeld" "Wolnzach" "Ravenna" "Civitavecchia" "Lonato"}
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder/view
     :layout true}]

   ["/compound/:compound-name/load-builder-v2"
    {:compound? true
     :enabled-compounds #{"Eitting" "Knautnaundorf" "Krefeld" "Wolnzach"}
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads-lbv2-live
     :view 'ductile.ui.load-builder-v2/view
     :layout true}]

   ["/compound/:compound-name/load-builder-v2/popup"
    {:compound? true
     :enabled-compounds #{"Eitting" "Knautnaundorf" "Krefeld" "Wolnzach"}
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder-v2/popup-view
     :layout true}]

   ["/compound/:compound-name/load-builder/popup-map"
    {:compound? true
     :enabled-compounds #{"Eitting" "Krefeld"}
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder/map-view
     :layout true}]

   ["/compound/:compound-name/load-builder/elog"
    {:compound? true
     :enabled-compounds #{"Wolnzach"}
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/merge-elog+fahrzeuge+loads
     :view 'ductile.ui.load-builder/view
     :layout true}]

   ["/compound/{compound/name}/vehicle-call-off/service-selection"
    {:enabled-compounds #{"Krefeld"}
     :scope :scope/inspect-workflow
     :compound? true
     :view 'ductile.ui.vehicle-call-off/render-vehicle-call-off
     :module :module/workflow
     :layout true}]

   ["/load-builder/{country/code}/popup-map"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder/map-view}]

   ["/load-builder/{country/code}"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder/view
     :layout true}]

   ["/load-builder/{country/code}/v2"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads-lbv2-live
     :view 'ductile.ui.load-builder-v2/view
     :layout true}]

   ["/load-builder-v2/{country/code}"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads-lbv2-live
     :view 'ductile.ui.load-builder-v2/view
     :layout true}]

   ["/load-builder/{country/code}/v2/popup"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder-v2/popup-view
     :layout true}]

   ["/load-builder-v2/{country/code}/popup"
    {:compound? false
     :module :module/workflow
     :scope :scope/dispo
     :fetch 'ductile.load-builder/fahrzeuge+loads
     :view 'ductile.ui.load-builder-v2/popup-view
     :layout true}]

   ["/loads/{ductile/id}/summary"
    {:compound? true
     :scope :scope/dispo
     :fetch 'ductile.transport/load-summary
     :view 'ductile.ui.transport/load-summary
     :layout true
     :module :module/workflow}]

   ["/carrier-billing"
    {:module :module/carrier-billing
     :scope :scope/carrier-billing
     :fetch 'ductile.carrier-billing/preview-form
     :view 'ductile.ui.carrier-billing/render-preview-form
     :layout true}]

   ["/billing"
    {:module :module/billing
     :scope :scope/billing
     :fetch 'ductile.billing/preview-form
     :view 'ductile.ui.billing/render-preview-form
     :layout true}]

   ["/invoices"
    {:module :module/workflow
     :scope :scope/billing
     :view 'ductile.ui.invoices/render-list
     :layout true}]

   ["/invoice/:invoice-number"
    {:module :module/workflow
     :scope :scope/invoices
     :name :nav/invoice-details
     :fetch 'ductile.billing/$load!
     :view 'ductile.ui.invoices/render-show}]

   ["/contracts"
    {:module :module/billing
     :scope :scope/billing
     :view 'ductile.ui.contract/render-show
     :layout true}]

   ["/edi/dashboard"
    {:scope #{:scope/developer :scope/edi}
     :view 'ductile.ui.edi/edi-dashboard
     :module :module/elog-interface
     :layout true}]

   ["/developer/simulate-frontend-errors"
    {:scope :scope/developer
     :view 'ductile.ui.compound/simulate-frontend-errors
     :module :module/workflow
     :layout true}]

   ["/developer/scenes"
    {:scope :scope/developer
     :view 'ductile.ui.scene.viewer/page
     :layout true}]

   ["/developer/scenes/:ns"
    {:scope :scope/developer
     :view 'ductile.ui.scene.viewer/page
     :layout true}]

   ["/developer/scenes/:ns/:id"
    {:scope :scope/developer
     :view 'ductile.ui.scene.viewer/page
     :layout true}]

   ["/locations"
    {:scope #{:scope/developer :scope/core-data.locations}
     :fetch 'ductile.locations/search
     :view 'ductile.ui.locations/overview
     :layout true
     :module :module/workflow}]

   ["/locations/new"
    {:module :module/workflow
     :scope #{:scope/dispo :scope/core-data.locations}
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-location-fields
     :layout true}]

   ["/locations/{ductile/id}/edit"
    {:module :module/workflow
     :scope #{:scope/core-data.locations :scope/dispo}
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-location-fields
     :layout true}]

   ["/compound/{compound/name}/gate/generate-self-checkin-link"
    {:module :module/workflow
     :scope #{:scope/manage-self-checkin}
     :view 'ductile.ui.gate/generate-self-checkin-link
     :fetch 'ductile.locations/all-carriers
     :layout true}]

   ["/compound/{compound/name}/gate/self-checkin"
    {:module :module/workflow
     :unauthenticated? true
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.gate-control/show-self-checkin-fields
     :layout true}]

   ["/compound/{compound/name}/gate/self-checkin/{ductile/id}"
    {:module :module/workflow
     :unauthenticated? true
     :view 'ductile.ui.gate/show-checkin
     :fetch 'ductile.gate-control/self-checkin
     :layout true}]

   ["/trucks"
    {:compound? true
     :module :module/workflow
     :scope :scope/trucks
     :view 'ductile.ui.transport/trucks-overview
     :fetch 'ductile.locations/trucks
     :layout true}]

   ["/compound/{compound/name}/carriers"
    {:compound? true
     :module :module/workflow
     :scope :scope/carriers
     :view 'ductile.ui.transport/carriers-overview
     :fetch 'ductile.locations/all-carriers
     :layout true}]

   ["/compound/{compound/name}/carriers/new"
    {:compound? true
     :module :module/workflow
     :scope :scope/carriers
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-carrier-fields
     :location/types :location.type/carrier ; TODO
     :layout true}]

   ["/compound/{compound/name}/carriers/{ductile/id}/edit"
    {:compound? true
     :module :module/workflow
     :scope :scope/carriers
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-carrier-fields
     :location/types :location.type/carrier ; TODO
     :layout true}]

   ["/trucks/new"
    {:module :module/workflow
     :scope :scope/trucks
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-truck-fields
     :layout true}]

   ["/trucks/{ductile/id}/edit"
    {:module :module/workflow
     :scope :scope/trucks
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.locations/show-truck-fields
     :layout true}]

   ["/interventions"
    {:scope :scope/developer
     :view 'ductile.ui.workflow/render-interventions
     :fetch 'ductile.interventions/fetch-interventions
     :module :module/interventions
     :layout true}]

   ["/compound/:compound-name/missing-destinations"
    {:scope #{:scope/developer :scope/compound-admin}
     :fetch 'ductile.locations/destinations-without-addresses
     :layout true
     :module :module/workflow}]

   ;; developer only
   ["/compound/:compound-name/announcements"
    {:name :nav/compound-announcements
     :compound? true
     :scope :scope/developer
     :module :module/workflow
     :view 'ductile.ui.announcements/render-announcements
     :layout true}]

   ;; vin lists office worker view, currently unused
   ["/compound/{compound/name}/vin-lists-overview"
    {:name :nav/vin-lists-inspector
     :compound? true
     :view 'ductile.ui.vin-list/render-vin-lists-inspector
     :scope :scope/vin-list
     :module :module/vin-list
     :fetch 'ductile.vin-list/fetch-vin-lists}]

   ["/compound/{compound/name}/vin-lists-overview/{ductile/id}"
    {:compound? true
     :view 'ductile.ui.vin-list/render-process-vin-list
     :scope :scope/vin-list
     :module :module/vin-list
     :fetch 'ductile.vin-list/fetch-vin-list}]

   ["/compound/{compound/name}/gate/gate-book"
    {:compound? true
     :module :module/workflow;;TODO: :module/gate-control
     :scope :scope/gate-control
     :view 'ductile.ui.gate/gate-book
     :fetch 'ductile.gate-control/gate-book-working-set
     :layout true}]

   ["/compound/{compound/name}/gate/visitors"
    {:compound? true
     :module :module/workflow;;TODO: :module/gate-control
     :scope :scope/gate-control
     :view 'ductile.ui.gate/visitors
     :fetch 'ductile.gate-control/visitors
     :layout true}]

   ["/compound/{compound/name}/gate/visitors/new"
    {:compound? true
     :module :module/workflow;;TODO: :module/gate-control
     :scope :scope/gate-control
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.gate-control/show-visitor-entry-fields
     :layout true}]

   ["/compound/{compound/name}/gate/deliveries/new"
    {:compound? true
     :module :module/workflow;;TODO: :module/gate-control
     :scope :scope/gate-control
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.gate-control/show-delivery-entry-fields
     :layout true}]

   ["/compound/:compound-name/transports"
    {:compound? true
     :module :module/workflow
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :view 'ductile.ui.transport/overview
     :fetch 'ductile.transport/overview
     :layout true}]

   ["/compound/:compound-name/exited-transports"
    {:compound? true
     :module :module/workflow
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :view 'ductile.ui.transport/overview
     :fetch 'ductile.transport/exited-overview
     :layout true}]

   ["/compound/:compound-name/entry-transports"
    {:compound? true
     :module :module/workflow
     :enabled-compounds #{"Civitavecchia" "Eitting" "Knautnaundorf" "Krefeld" "Ravenna" "Lonato"}
     :scope #{#_:scope/transports-overview :scope/inspect-workflow :scope/train-entry}
     :view 'ductile.ui.transport/entry-overview
     :fetch 'ductile.transport/entry-overview
     :layout true}]

   ["/compound/:compound-name/loads-search"
    {:compound? true
     :module :module/workflow
     :scope #{#_:scope/transports-overview :scope/inspect-workflow}
     :view 'ductile.ui.transport/loads-search
     :fetch 'ductile.transport/loads-search
     :layout true}]

   ["/compound/:compound-name/transports/{ductile/id}"
    {:compound? true
     :scope #{:scope/inspect-workflow :scope/train-entry :scope/transports-overview}
     :view 'ductile.ui.transport/show-transport
     :fetch 'ductile.transport/show
     :layout true
     :module :module/workflow}]

   ["/compound/:compound-name/bill-of-lading/{ductile/id}"
    {:compound? true
     :unauthenticated? true ;; we send a link to customer with it
     :fetch 'ductile.transport/bill-of-lading
     :view 'ductile.ui.transport/bill-of-lading
     :layout true
     :module :module/workflow}]

   ["/transport-ops/:transport-id/confirm-delivery/{ductile/id}"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/bill-of-lading
     :view 'ductile.ui.transport/confirm-delivery
     :module :module/workflow}]

   ["/transport-ops/{ductile/id}"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/route-plan
     :view 'ductile.ui.transport/transport-ops
     :module :module/workflow}]

   ["/transport-ops/{ductile/id}/confirm-loading"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/route-plan
     :view 'ductile.ui.transport/confirm-loading
     :module :module/workflow}]

   ["/report-damages/:fahrzeug-id"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.report-damages/fahrzeug
     :view 'ductile.ui.report-damages/render-report
     :module :module/workflow}]

   ["/compound/:compound-name/transports/{ductile/id}/load-list"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow :scope/compound-dispo :scope/dispo}
     :fetch 'ductile.load-list/show
     :layout true
     :module :module/workflow}]

   ["/compound/:compound-name/transports/{ductile/id}/route-plan"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/route-plan
     :view 'ductile.ui.transport/route-plan
     :layout true
     :module :module/workflow}]

   ["/route-plan/{ductile/id}"
    {:unauthenticated? true
     :fetch 'ductile.transport/route-plan
     :view 'ductile.ui.transport/mobile-route-plan
     :module :module/workflow}]

   ["/compound/:compound-name/transports/{ductile/id}/mobile-route-plan"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/route-plan
     :view 'ductile.ui.transport/mobile-route-plan
     :module :module/workflow}]

   ["/compound/:compound-name/bill-of-lading/{ductile/id}/trace"
    {:compound? true
     :unauthenticated? true ;; we send a link to customer with it
     :fetch 'ductile.transport/trace
     :layout true
     :module :module/workflow}]

   ["/entity/{entity/type}/{ductile/id}"
    {:fetch 'ductile.entity-search/build-entity-map
     :view 'ductile.ui.entity/entity-view
     :layout true}]

   ;; compound worker / mobile device homepage
   ["/compound-ops/:compound-name"
    {:compound? true
     :scope #{:scope/service-list :scope/workflow :scope/vehicle-exit-verification}
     :module :module/workflow
     :fetch 'ductile.service-list/fetch-lists+compound-config
     :view 'ductile.ui.workflow/compound-ops}]

   ["/compound-ops/:compound-name/flow/{workflow/type}"
    {:compound? true
     :view 'ductile.ui.workflow/workflow
     :fetch 'ductile.workflow/build-workflow-map
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/flow/{workflow/type}/{ductile/id}"
    {:compound? true
     :view 'ductile.ui.workflow/workflow
     :fetch 'ductile.workflow/build-workflow-map
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/arrival-scan"
    {:compound? true
     :view 'ductile.ui.workflow/workflow
     :fetch 'ductile.workflow/build-workflow-map
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/storage-rows-with-free-spots"
    {:compound? true
     :view 'ductile.ui.workflow/render-storage-rows-with-free-spots
     :fetch 'ductile.insights.parking-spots/storage-rows-with-free-spots
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/workflow/:fahrzeug-id"
    {:compound? true
     :view 'ductile.ui.workflow/workflow
     :fetch 'ductile.workflow/build-workflow-map
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/workflow/exit/verification"
    {:compound? true
     :scope :scope/vehicle-exit-verification
     :module :module/workflow
     :view 'ductile.ui.workflow/render-exit-verification}]

   ["/compound-ops/:compound-name/workflow/exit/ship"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :fetch 'ductile.transport/exit-ships
     :view 'ductile.ui.workflow/ship-exit-overview}]

   ["/compound-ops/:compound-name/workflow/exit/ship/:transport-id"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :fetch 'ductile.transport/bulk-transport-progress
     :view 'ductile.ui.workflow/ship-exit}]

   ["/compound-ops/:compound-name/workflow/exit/ship/:transport-id/exit-service/:fahrzeug-id"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :fetch 'ductile.workflow/build-fahrzeug
     :on-fetch :ductile.ui.workflow/select-ship-loading-service!
     :view 'ductile.ui.workflow/workflow}]

   ["/compound-ops/:compound-name/workflow/entry-ship/:transport-name"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :fetch 'ductile.transport/entry-transport-progress
     :view 'ductile.ui.workflow/ship-entry-details-view}]

   ["/compound-ops/:compound-name/workflow/entry/ship/:transport-id"
    {:compound? true
     :view 'ductile.ui.workflow/ship-entry
     :fetch 'ductile.transport/bulk-transport-progress
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/workflow/entry/ship"
    {:compound? true
     :scope :scope/inspect-workflow
     :module :module/workflow
     :fetch 'ductile.transport/entry-ships
     :view 'ductile.ui.workflow/ship-entry-overview}]

   ["/compound-ops/:compound-name/workflow/entry/truck"
    {:compound? true
     :view 'ductile.ui.workflow/truck-entry
     :module :module/workflow
     :scope :scope/compound-entry}]
   ["/compound-ops/:compound-name/workflow/entry/train"
    {:compound? true
     :view 'ductile.ui.workflow/train-entry
     :module :module/workflow
     :scope :scope/compound-entry}]

   ["/compound-ops/:compound-name/bulk-arrival-scan"
    {:compound? true
     :scope :scope/compound-entry
     :module :module/workflow
     :fetch 'ductile.transport/open-bulk-entry-transports
     :view 'ductile.ui.workflow/bulk-arrival-scan-overview}]

   ["/compound-ops/:compound-name/bulk-arrival-scan/:transport-id"
    {:compound? true
     :scope :scope/compound-entry
     :module :module/workflow
     :fetch 'ductile.transport/bulk-transport-progress
     :view 'ductile.ui.workflow/bulk-arrival-scan}]

   ["/compound-ops/:compound-name/workflow/entry/own-wheels"
    {:compound? true
     :view 'ductile.ui.workflow/own-wheels-entry
     :module :module/workflow
     :scope :scope/compound-entry}]

   ["/compound-ops/:compound-name/workflow/mode/parking"
    {:compound? true
     :view 'ductile.ui.workflow/render-parking-mode
     :module :module/workflow
     :scope :scope/workflow}]

   ["/compound-ops/:compound-name/service-lists/:service-list-type"
    {:compound? true
     :view 'ductile.ui.service-list/service-list
     :fetch 'ductile.service-list/query
     :module :module/workflow
     :scope :scope/service-list}]

   ["/compound-ops/:compound-name/elog-interface/services"
    {:compound? true
     :view 'ductile.ui.elog.interface/render-list
     :fetch 'ductile.elog.interface/fetch-list
     :scope :scope/elog-service-completion
     :module :module/elog-interface
     :layout true}]

   ["/compound-ops/:compound-name/elog-scanner"
    {:compound? true
     :view 'ductile.ui.workflow/elog-scanner
     :module :module/workflow
     :scope :scope/developer}]

   ["/compound-ops/:compound-name/ars-id-coupling"
    {:compound? true
     :enabled-compounds #{}
     :view 'ductile.ui.workflow/workflow
     :fetch 'ductile.workflow.ars-id-coupling/coupling-fahrzeug
     :layout true
     :module :module/workflow
     :scope :scope/developer}]

   ["/compound-ops/:compound-name/workflow-simulator"
    {:compound? true
     :enabled-compounds #{"Krefeld" "Eitting"}
     :fetch 'ductile.workflow.simulator/scenarios
     :view 'ductile.ui.workflow/simulator
     :layout true
     :module :module/workflow
     :scope :scope/developer}]

   ["/compound/:compound-name/print/sixt-labels-small/{ductile/id}"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/show
     :view 'ductile.ui.labels/sixt-labels-small
     :layout true
     :module :module/workflow}]

   ["/compound/:compound-name/print/sixt-labels-big/{ductile/id}"
    {:compound? true
     :scope #{:scope/transports-overview :scope/inspect-workflow}
     :fetch 'ductile.transport/show
     :view 'ductile.ui.labels/sixt-labels-big
     :layout true
     :module :module/workflow}]

   ;; truck booking entry point for external people
   ["/unloadings/bookings"
    {:module :module/truck-booking
     :scope :scope/schedule-unloading
     :fetch 'ductile.truck-booking/unloadings-by-user
     :view 'ductile.ui.truck-booking/render-bookings-overview}]

   ;; creating a new booking
   ["/unloadings/book"
    {:module :module/truck-booking
     :scope :scope/schedule-unloading
     :view 'ductile.ui.truck-booking/render-booking}]

   ;; dashboard for bookings
   ["/unloadings/:compound-name/inspect"
    {:compound? true
     :module :module/truck-booking
     :scope :scope/inspect-unloadings
     :view 'ductile.ui.truck-booking/render-unloadings-inspector
     :layout true}]

   ;; alternative dashboard view
   ["/unloadings/:compound-name/slots-overview"
    {:compound? true
     :layout true
     :module :module/truck-booking
     :scope :scope/unloading-opening-times
     :view 'ductile.ui.truck-booking/render-slots-overview}]

   ;; compound worker
   ["/unloadings/:compound-name/manage-status"
    {:compound? true
     :module :module/truck-booking
     :scope :scope/unloading-status
     :fetch 'ductile.truck-booking/active-unloadings
     :view 'ductile.ui.truck-booking/render-unloading-manage-status}]

   ;; compound gate using this
   ["/unloadings/:compound-name/reception"
    {:compound? true
     :module :module/truck-booking
     :scope :scope/unloading-reception
     :fetch 'ductile.truck-booking/unloading-reception
     :view 'ductile.ui.truck-booking/render-unloading-reception}]

   ;; compound worker
   ["/accessories/:compound-name"
    {:module :module/accessories
     :scope :scope/scan-accessory-list
     :view 'ductile.ui.accessories/render-accessories}]

   ["/vin-list/{compound/name}"
    {:compound? true
     :module :module/vin-list
     :scope :scope/vin-list
     :fetch 'ductile.vin-list/fetch-vin-lists
     :view 'ductile.ui.vin-list/render-vin-lists}]

   ["/vin-list/{compound/name}/{ductile/id}"
    {:compound? true
     :module :module/vin-list
     :scope :scope/vin-list
     :fetch 'ductile.vin-list/fetch-vin-list
     :view 'ductile.ui.vin-list/render-vin-list-show}]

   ["/login"
    {:module :module/base
     :view 'ductile.ui.auth/render-login
     :unauthenticated? true}]

   ["/signup"
    {:module :module/base
     :view 'ductile.ui.auth/render-signup
     :unauthenticated? true}]

   ["/websocket-status"
    {:scope :scope/developer
     :fetch 'ductile.http.websocket/status
     :layout true
     :module :module/base}]

   ["/cron-status"
    {:scope :scope/developer
     :fetch 'ductile.cron-jobs/status
     :layout true
     :module :module/base}]

   ["/users"
    {:module :module/base
     :view 'ductile.ui.users/render-user-dashboard
     :scope #{:scope/user-scopes :scope/compound-users}
     :fetch 'ductile.users/search
     :layout true}]

   ["/users/new"
    {:module :module/base
     :scope #{:scope/developer :scope/user-scopes :scope/compound-users}
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.users/show-user-fields
     :layout true}]

   ["/users/{ductile/id}/edit"
    {:module :module/workflow
     :scope :scope/developer
     :view 'ductile.ui.workflow/form
     :fetch 'ductile.users/show-user-fields
     :layout true}]

   ["/insights/:compound-name/train-forecast"
    {:fetch 'ductile.insights.train-forecast/report
     :enabled-compounds #{"Ravenna"}
     :scope :scope/inspect-workflow
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/exit-trains"
    {:fetch 'ductile.insights.exit-train/report
     :enabled-compounds #{"Lonato" "Civitavecchia"}
     :scope :scope/inspect-workflow
     :module :module/workflow
     :layout true}]


   ["/insights/:compound-name/ars-id-coupling"
    {:fetch 'ductile.workflow.ars-id-coupling/report
     :enabled-compounds #{}
     :scope :scope/inspect-workflow
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/bmw-credit-notes"
    {:fetch 'ductile.insights.bmw-credit-notes/report
     :enabled-compounds #{"Krefeld"}
     :scope :scope/developer
     :module :module/billing
     :layout true}]

   ["/insights/:compound-name/conspicuous-fueling-services"
    {:fetch 'ductile.insights.conspicuous-fueling-services/report
     :enabled-compounds #{"Krefeld" "Eitting"}
     :scope :scope/developer
     :module :module/billing
     :layout true}]

   ["/insights/kia-edi-errors"
    {:fetch 'ductile.insights.kia-edi-errors/report
     :scope :scope/developer
     :enabled-compounds #{"Civitavecchia" "Lonato"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/flow-report"
    {:fetch 'ductile.insights.flow-report/report
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Ravenna"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/customs-overview"
    {:fetch 'ductile.insights.customs-overview/show
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Civitavecchia"}
     :module :module/workflow
     :layout true}]


   ["/insights/:compound-name/contracts"
    {:module :module/billing
     :scope :scope/billing
     :fetch 'ductile.contract/overview
     :enabled-compounds #{"Krefeld"}
     :layout true}]

   ["/insights/:compound-name/elog-import-report"
    {:fetch 'ductile.elog.import-report/report
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Eitting"}
     :layout true}]

   ["/insights/:compound-name/completed-services"
    {:fetch 'ductile.insights.completed-services/report
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Krefeld" "Eitting" "Ravenna" "Lonato" "Civitavecchia" "Riedstadt" "Hodenhagen"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/active-services"
    {:fetch 'ductile.insights.active-services/report
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Eitting" "Knautnaundorf" "Krefeld" "Ravenna" "Lonato" "Civitavecchia" "Riedstadt" "Hodenhagen"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/untouched-fahrzeuge-report"
    {:fetch 'ductile.insights.untouched-fahrzeuge-report/dashboard
     :scope :scope/compound-admin
     :enabled-compounds #{"Eitting" "Krefeld"}
     :module :module/workflow
     :layout true}]

   ["/insights/{compound/name}/reports"
    {:fetch 'ductile.insights.reports/dashboard
     :view 'ductile.ui.compound/compound-report-dashboard
     :scope #{:scope/pegaso-monitoring
              :scope/developer
              :scope/compound-admin
              :scope/inspect-workflow
              :scope/report-api
              :scope/billing} ;; TODO automate this with (report-scopes)
     :enabled-compounds #{"Krefeld" "Eitting" "Lonato" "Ravenna" "Civitavecchia" "Knautnaundorf" "Riedstadt" "Hodenhagen" "Wolnzach" "Fiumicino"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/parking-spots"
    {:fetch 'ductile.insights.parking-spots/overview
     :view 'ductile.ui.compound/parking-spots
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Krefeld" "Eitting" "Knautnaundorf"}
     :module :module/workflow
     :layout true}]

   ["/insights/{compound/name}/reports/{report/id}"
    {:fetch 'ductile.insights.reports/report
     :view 'ductile.ui.compound/compound-report-show
     :scope #{:scope/pegaso-monitoring
              :scope/developer
              :scope/compound-admin
              :scope/inspect-workflow
              :scope/report-api
              :scope/billing} ;; TODO automate this with (report-scopes)
     :enabled-compounds #{"Krefeld" "Eitting" "Lonato" "Ravenna" "Civitavecchia" "Knautnaundorf" "Fiumicino"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/kia-reports/edi"
    {:fetch 'ductile.insights.kia-reports/report-edi-call-offs
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Lonato" "Civitavecchia"}
     :module :module/workflow
     :layout true}]

   ["/insights/:compound-name/kia-reports/carpets"
    {:fetch 'ductile.insights.kia-reports/report-carpets
     :scope :scope/inspect-workflow
     :enabled-compounds #{"Lonato" "Civitavecchia"}
     :module :module/workflow
     :layout true}]

   ["/insights/billing-reports/missing-model-transport-prices"
    {:fetch 'ductile.insights.transport-billing/report-missing-model-transport-prices
     :scope :scope/carrier-billing
     :module :module/workflow
     :layout true}]
   ["/nexus"
    {:view 'ductile.ui.nexus/view
     :scope :scope/developer
     :layout true}]
   ["/schema-based-editor"
    {:view 'ductile.ui.schema-based-editor/view
     :scope :scope/developer
     :layout true}]])

;; keep old implemenation to compare old to new in tests
(defn ->template [path]
  (mapv #(if (str/starts-with? % ":")
           (keyword (subs % 1))
           (symbol %))
        (rest (str/split path #"/"))))

(defn path->template [path]
  (into []
        (mapcat (fn [segment]
                  (when-not (= "/" segment)
                    (cond
                      (string? segment) (map symbol (rest (str/split segment #"/")))
                      (reitit.trie/wild? segment) [(:value segment)]
                      (reitit.trie/catch-all? segment) [(symbol (str "*" (name (:value segment))))]))))
        (reitit.trie/split-path path {})))

(comment
  (path->template "/compound/:compound-name")
  (path->template "/load-builder/{country/code}")
  (path->template "/compound/:compound/name/load-builder")
  (path->template "/compound/{compound/name}/intervention/{ductile/base64-edn}")
  (path->template "/vin-list/{compound/name}/{ductile/id}")
  (path->template "/foo/*barx")
  (path->template "/a/:b/:c/d/e/f/g/:h")
  (path->template "/a/:b/:c/d/e/f/g/")
  (path->template "/a/:b/:c/d/e/f/g")
  (path->template "/compound-ops/:compound-name/workflow/entry/own-wheels"))

#_(->template "/compound/:compound-name")
#_(->template "/snapshot/*path/")

(def template-nested-path (reduce (fn [acc [path data]]
                                    (assoc-in acc (path->template path) data))
                                  {}
                                  routes))


(defn template->data [template]
  (reduce (fn [acc fragment]
            (get acc fragment (some-> (filter (comp keyword? key) acc)
                                      first
                                      val)))
          template-nested-path
          template))

(comment
  (template->data '[unloadings bookings]))

(defn nav
  "Nested localization."
  []
  [{:label (tr "Dashboard") :template '[compound :compound-name]}
   {:label (tr "Truck Booking")
    :items [{:label (tr "Book unloading") :template '[unloadings book]}
            {:label (tr "Reception Desk") :template '[unloadings :compound-name reception]}
            {:label (tr "Opening hours") :template '[unloadings :compound-name slots-overview]}
            {:label (tr "Bookings") :template '[unloadings :compound-name inspect]}]}
   {:label (tr "Gate")
    :items [{:label (tr "Visitors")
             :template '[compound :compound/name gate visitors]}
            {:label (tr "Gate Book")
             :template '[compound :compound/name gate gate-book]}
            {:label (tr "Generate Check-in Link")
             :template '[compound :compound/name gate generate-self-checkin-link]}]}
   {:label (tr "Vehicles")
    :items [{:label (tr "AI Agent")
             :description (tr "Chat with the AI agent about vehicles")
             :template '[agent]}
            {:label (tr "Import announced vehicles")
             :description (tr "Import annouced vehicles from an Excel file")
             :template '[compound :compound/name wizard import-announced-fahrzeuge]
             :enabled-compounds #{"Eitting" "Krefeld"}
             :scope #{:scope/compound-fahrzeug-announcements}}
            {:label (tr "Fahrzeug Import")
             :template '[compound :compound/name wizard fahrzeug-import]
             :enabled-compounds #{"Lonato" "Civitavecchia" "Ravenna"}
             :scope #{:scope/compound-fahrzeug-announcements}}
            {:label (tr "Search")
             :description (tr "Find vehicles based on search params or a list of VINs")
             :template '[compound :compound/name vehicle-search] :query-string "entry/datetime={}&exit/datetime=:ductile.vehicle-search/missing"}
            {:label (tr "Call-Off")
             :description (tr "Call-off multiple vehicles at once via search params or a list of VINs")
             :template '[compound :compound/name vehicle-call-off]}
            {:label (tr "Load Builder")
             :description (tr "Create new transports based on a map route and filters")
             :template '[compound :compound-name load-builder]}
            {:label [:span.inline-flex.items-center.gap-1
                     (tr "Load Builder V2")
                     [:span.inline-flex.rounded.bg-orange-100.text-orange-800.px-1.py-0.font-bold
                      {:class "text-[10px] leading-4"}
                      "BETA"]]
             :description (tr "Create new transports based on a map route and filters")
             :template '[compound :compound-name load-builder-v2]}
            {:label (tr "Create entry transport")
             :description (tr "Create entry transports for multiple vehicles via search params or a list of VINs")
             :template '[compound :compound/name create-entry-transport]}
            {:label (tr "Create exit transport")
             :description (tr "Create exit transports for multiple vehicles (e.g. for self-pickup) via search params or a list of VINs")
             :template '[compound :compound/name create-exit-transport]}
            {:label (tr "Entry Transports") :template '[compound :compound-name entry-transports]}
            {:label (tr "Transports")
             :description (tr "A list of all currently open transports")
             :template '[compound :compound-name transports]}
            {:label (tr "Trucks")
             :template '[compound :compound-name trucks]}]}
   {:label (tr "VIN Lists") :template '[vin-list :compound/name]}
   {:label (tr "Core Data")
    :items [{:label (tr "Carriers") :template '[compound :compound/name carriers]}
            {:label (tr "Trucks") :template '[trucks]}
            {:label (tr "Locations") :template '[locations]}
            {:label (tr "Merge Locations") :template '[wizard location-merge] :scope #{:scope/core-data.locations}}
            {:label (tr "Import Accessories") :template '[wizard import-accessories] :scope #{:scope/core-data.oem-data}}
            {:label (tr "Assign license plates") :template '[wizard assign-license-plates] :scope #{:scope/core-data.oem-data}}
            {:label (tr "Customs Clearance") :template '[wizard customs-clearance] :scope #{:scope/customs-clearance}}]}
   {:label (tr "Billing")
    :items [{:label (tr "Contracts") :template '[contract-terms]}
            {:label (tr "Find Invoice") :template '[invoices]}
            {:label (tr "Create invoice") :template '[billing]}
            {:label (tr "Carrier Billing") :template '[carrier-billing]}
            {:label (tr "Fuel Prices") :template '[fuel-prices]}]}
   {:label (tr "Services")
    :items [{:label (tr "Active Services") :template '[insights :compound-name active-services]}
            {:label (tr "Completed services") :template '[insights :compound-name completed-services]}
            {:label (tr "ELOG Services") :template '[compound-ops :compound-name elog-interface services]}
            {:label (tr "Workflows") :template '[workflows]}
            {:label (str (tr "Workflows") " 2") :template '[compound :compound-name workflows]}]}
   {:label (tr "Users") :template '[users]}
   {:label (tr "Reports") :template '[insights :compound/name  reports]}
   {:label (tr "Developer")
    :scope #{:scope/edi :scope/developer}
    :items (concat
            [{:label (tr "EDI Dashboard") :template '[edi dashboard] :scope #{:scope/edi :scope/developer}}]
            (mapv
             #(assoc % :scope :scope/developer)
             [{:label (tr "Announcements") :template '[compound :compound-name announcements]}
              {:label (tr "Compound Ops") :template '[compound-ops :compound-name] :mobile? true}
              {:label (tr "Defscenes") :template '[developer scenes]}
              {:label (tr "Interventions") :template '[interventions]}
              {:label (tr "ELOG Importer") :template '[compound :compound-name elog-importer]}
              {:label (tr "EDI Status") :template '[compound :compound-name entry-edi]}
              {:label (tr "Missing destination addresses") :template '[compound :compound-name missing-destinations]}
              {:label (tr "Cron Status") :template '[cron-status]}
              {:label (tr "Websocket Status") :template '[websocket-status]}]))}])

(comment
  (binding [locale/*current-locale* :it] (nav))
  (binding [locale/*current-locale* :de] (nav)))

(defn update-some
  "Like `update`, but only applies the function if the key exists in the map."
  [m k f & args]
  (if (contains? m k)
    (apply update m k f args)
    m))

(defn build-nav [{:keys [compound-name user]}]
  (if compound-name
    (into []
          (keep (fn process-item [{:as item :keys [scope template items enabled-compounds]}]
                  (when (or (not scope)
                            (scope-auth/authorized-for? (:user/read-scopes user) scope))
                    (let [{:as route-data :keys [enabled-compounds module]} (template->data template)
                          route-enabled-compounds (or enabled-compounds (:enabled-compounds route-data))
                          compound-enabled? (or (not route-enabled-compounds)
                                                (contains? enabled-compounds compound-name))
                          module-enabled? (or (not (:compound? route-data))
                                              (and compound-name (compound-config/module-enabled? compound-name module)))
                          item (update-some item :items (partial keep process-item))
                          required-scope (or scope (:scope route-data))]
                      (if (seq (:items item)) ;;visible children
                        item
                        (when (and module-enabled? compound-enabled?)
                          (scope-auth/protect-value required-scope (:user/read-scopes user) item)))))))
          (nav))
    []))

(defn frontpage-items
  "Items to include on the frontpage given the `compound-name` (can be nil) or `user-scopes`"
  [{:as opts :keys [compound-name user]}]
  ;; we're not programmatically generating the labels from the `nav`
  ;; because they're slightly different e.g. Dashboard vs Compound Dashboard
  (into []
        (keep (fn can-access? [{:as item :keys [template]}]
                (let [{:as route-data :keys [scope module enabled-compounds]} (or (template->data template)
                                                                                  (throw (ex-info "could not find url data for template"
                                                                                                  {:template template
                                                                                                   :template->data template})))
                      compound-enabled? (or (not enabled-compounds)
                                            (contains? enabled-compounds compound-name))
                      module-enabled? (or (not (:compound? route-data))
                                          (and compound-name (compound-config/module-enabled? compound-name module)))]
                  (when (and compound-enabled? module-enabled?)
                    (scope-auth/protect-value scope (:user/read-scopes user) item)))))
        [{:label (tr "Book unloading") :template '[unloadings bookings]}
         {:label (tr "Accessories") :template '[accessories :compound-name]}
         {:label (tr "Manage Unloadings") :template '[unloadings :compound-name manage-status]}
         {:label (tr "Unloading Reception") :template '[unloadings :compound-name reception]}
         {:label (tr "Inspect Unloadings") :template '[unloadings :compound-name inspect]}
         {:label (tr "Compound Ops") :template '[compound-ops :compound-name]}
         {:label (tr "Compound Dashboard") :template '[compound :compound-name]}
         {:label (tr "Transports") :template '[compound :compound-name transports]}
         {:label (tr "VIN Lists") :template '[vin-list :compound/name]}
         {:label (tr "VIN List overview") :template '[compound :compound/name vin-lists-overview]}
         {:label (tr "Services") :template '[compound-ops :compound-name elog-interface services]}
         {:label (tr "Passive Custody Portal") :template '[compound :compound/name passive-custody]}
         {:label (tr "Customer Portal") :template '[compound :compound/name customer-portal]}
         {:label (tr "Insurance Portal") :template '[compound :compound/name insurance-portal]}
         {:label (tr "Compound Load Builder") :template '[compound :compound-name load-builder]}
         {:label (tr "Load Builder") :template '[load-builder :country/code]}]))

(comment
  (frontpage-items {:compound-name "Ravenna" :user {:user/scopes scope-auth/all-scopes}})
  (frontpage-items {:compound-name "Piadena" :user {:user/scopes scope-auth/all-scopes}})
  (frontpage-items {:compound-name "Piadena" :user {:user/scopes #{:scope/unloading-reception}}})
  (frontpage-items {:user {:user/scopes #{:scope/schedule-unloading}}})
  (frontpage-items {:user {:user/scopes #{:scope/unloading-reception}}})
  (frontpage-items {:user {:user/scopes #{:scope/workflow}}}))

;;TODO remove in favor of reitit-path
(defn path
  ([url-template] (path url-template {}))
  ([url-template path-params] (if (sequential? url-template)
                                (path url-template path-params nil)
                                ;; is actually (r/match->path match query-params)
                                (r/match->path url-template path-params)))
  ([url-template path-params query-string]
   (when-let [missing-params  (not-empty (clojure.set/difference (into #{} (filter keyword?) url-template)
                                                                 (set (keys path-params))))]
     (throw (ex-info (str "missing required params: " (str/join "," missing-params)) {:missing-params missing-params :path-params path-params :url-template url-template})))
   (str "/" (str/join "/" (mapv #(if (keyword? %) (get path-params %) %) url-template)) (some->> query-string (str "?")))))

(defn reitit-path
  ([url-template] (reitit-path url-template {} nil))
  ([url-template path-params] (reitit-path url-template path-params nil))
  ([url-template path-params query-string]
   (cond->> (-> (r/match-by-name (r/router [[url-template {:name ::route}]]) ::route path-params)
                (r/match->path))
     query-string (str "?"))))

#_(reitit-path "/compound/{compound/name}/wizard/{wizard/name}/{ductile/base64-edn}"
               {:compound/name "Eitting"
                :wizard/name "interventions"
                :ductile/base64-edn "e30"})

(defn absolute-path
  [system & params]
  (str #?(:clj (-> system :ductile/config :service-url)
          :cljs (.-origin (.-location js/window))) (apply path params)))

(defn cas-path
  [system cas-entity]
  (absolute-path system '[cas :cas/multihash] cas-entity))

(def query-string reitit.impl/query-string)

(comment
  (path '[compound :compound-name] {:compound-name "Krefeld"})
  (path '[compound :compound-name] {}))

(defn migrate-legacy-params
  "Migration of legacy unnamespaced params until routes have been
  migrated to use namespaced params."
  [params]
  (set/rename-keys params {:compound-name :compound/name
                           :ductile-id :ductile/id}))
